/**
 * Canonical playback / streaming events for plugins and host apps.
 * Sprint 6A aliases (READY/PLAY/…) mirror PlaybackPlatformEvent for BC.
 * Prefer PlaybackPlatformEvent + PlaybackEventBus for new platform code.
 */
export const PlayerEvent = Object.freeze({
  PLAYER_READY: "PlayerReady",
  PLAYBACK_STARTED: "PlaybackStarted",
  PLAYBACK_PAUSED: "PlaybackPaused",
  PLAYBACK_STOPPED: "PlaybackStopped",
  PLAYBACK_ENDED: "PlaybackEnded",
  BUFFER_STARTED: "BufferStarted",
  BUFFER_ENDED: "BufferEnded",
  SEEK_STARTED: "SeekStarted",
  SEEK_COMPLETED: "SeekCompleted",
  QUALITY_CHANGED: "QualityChanged",
  PLAYBACK_ERROR: "PlaybackError",
  RETRY_ATTEMPT: "RetryAttempt",
  SOURCE_CHANGED: "SourceChanged",
  STATE_CHANGED: "StateChanged",
  TIME_UPDATE: "TimeUpdate",
  VOLUME_CHANGED: "VolumeChanged",
  MUTE_CHANGED: "MuteChanged",
  RATE_CHANGED: "RateChanged",
  FULLSCREEN_CHANGED: "FullscreenChanged",
  FULLSCREEN_ENTER: "FullscreenEnter",
  FULLSCREEN_EXIT: "FullscreenExit",
  PIP_CHANGED: "PictureInPictureChanged",
  PROVIDER_CHANGED: "ProviderChanged",
  NETWORK_UPDATE: "NetworkUpdate",
  RECOVERED: "Recovered",
  PROVIDER_SUBTITLES_CHANGED: "ProviderSubtitlesChanged",
  // Phase 3
  TEXT_TRACKS_CHANGED: "TextTracksChanged",
  TEXT_TRACK_SELECTED: "TextTrackSelected",
  AUDIO_TRACKS_CHANGED: "AudioTracksChanged",
  AUDIO_TRACK_SELECTED: "AudioTrackSelected",
  CHAPTERS_CHANGED: "ChaptersChanged",
  CHAPTER_SELECTED: "ChapterSelected",
  RESUME_OFFERED: "ResumeOffered",
  RESUME_APPLIED: "ResumeApplied",
  PROGRESS_SAVED: "ProgressSaved",
  ANNOUNCEMENT: "Announcement",
  // Sprint 6A aliases
  READY: "PlayerReady",
  PLAY: "PlaybackStarted",
  PAUSE: "PlaybackPaused",
  STOP: "PlaybackStopped",
  SEEK_START: "SeekStarted",
  SEEK_COMPLETE: "SeekCompleted",
  PROGRESS: "TimeUpdate",
  BUFFERING: "BufferStarted",
  BUFFERED: "BufferEnded",
  ENDED: "PlaybackEnded",
  ERROR: "PlaybackError",
  PLAYBACK_RATE_CHANGED: "RateChanged",
  SUBTITLE_CHANGED: "TextTrackSelected",
  AUDIO_TRACK_CHANGED: "AudioTrackSelected",
});

export default PlayerEvent;
